<template>
  <div class="dashboard">
    <div class="booster-list-page">
      <!-- 固定顶部导航栏 -->
      <div class="fixed-header">
        <div class="sub-header">
          <div class="head_info">
            <span> 新建助推 </span>
          </div>
          <div class="filtrate">
            <div class="fit_item">
              <picker-selector
                v-model="parameter.productId"
                :options="allProducts"
                placeholder="全部产品"
                @change="handleProductSelect"
              />
            </div>
            <div class="fit_item">
              <picker-selector
                v-model="parameter.advertiserId"
                :options="allAdvert"
                search-mode="account"
                placeholder="全部账户"
                @change="handleAdvertSelect"
              />
            </div>
            <div class="fit_item">
              <van-field
                class="enter-input"
                @input="changeInput"
                v-model="parameter.orderId"
                placeholder="请输入星视频订单"
              />
            </div>
          </div>
          <!-- 选择状态栏 -->
          <div class="selection-status">
            <span class="selected-count">已选择：{{ selectedCount }}条</span>
            <div>
              <a href="#" @click="selectAll">全选</a>
              <a href="#" @click="clearSelection">清空</a>
            </div>
          </div>
        </div>
      </div>
      <!-- 列表块 -->
      <div class="van_list">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="handleQueryBotoomOut"
          offset="10"
        >
          <van-swipe-cell
            v-for="(item, index) in list"
            :key="index"
            :class="{ selected: selectedItems.includes(item.orderId) }"
          >
            <div class="booster-item" @click="toggleSelect(item.orderId)">
              <van-row class="item-stats">
                <van-col span="16"
                  ><span style="flex: 2"
                    >发布时间: {{ item.starReleaseTime }}</span
                  ></van-col
                >
                <van-col span="8"
                  ><span style="">{{
                    getStatusLabel(item.orderStatus)
                  }}</span></van-col
                >
              </van-row>
              <!-- <div class="item-stats">
                <span style="flex: 2;">发布时间: {{ item.starReleaseTime }}</span>
                <span style="">{{ getStatusLabel(item.orderStatus) }}</span>
              </div> -->
              <van-row class="special-time">
                <van-col span="8"
                  ><span style="flex: 2">{{ item.orderId }}</span></van-col
                >
                <van-col span="4"
                  ><span>{{ item.advertiserId }}</span></van-col
                >
                <van-col span="4"
                  ><span>{{ item.productName }}</span></van-col
                >
                <van-col span="8"
                  ><span style="flex: 2">{{ item.starName }}</span></van-col
                >
              </van-row>
              <!-- <div class="special-time">
                <span style="flex: 2;">{{ item.orderId }}</span>
                <span>{{ item.advertiserId }}</span>
                <span>{{ item.productName }}</span>
                <span style="flex: 2;">{{ item.starName }}</span>
              </div> -->
            </div>
          </van-swipe-cell>
        </van-list>
      </div>
      <!-- 下一步 -->
      <div
        class="next_step"
        @click.stop="selectedCount > 0 ? pushAddBoost() : null"
        :style="{ color: selectedCount > 0 ? '#000000' : '#cfcfcf' }"
      >
        下一步
      </div>
      <!-- <app-tab-bar /> -->
    </div>
  </div>
</template>

<script>
import PickerSelector from "@/components/PickerSelector.vue";

// import AppTabBar from "@/components/TabBar.vue";
import { ProductData, AccountData } from "@/api/modules/home";
import { getnewBoostList } from "@/api/modules/newboose";

export default {
  name: "NewBoostPage",
  components: {
    // AppTabBar,
    PickerSelector,
  },
  data() {
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const today = new Date();
    const todayStr = formatDate(today);
    return {
      allProducts: [],
      allAdvert: [],
      parameter: {
        pageNo: 1,
        pageSize: 20,
        productId: "",
        advertiserId: "",
        orderId: "",
        supplementOrderId: "",
        orderBy: "",
        supplementOrderType: "",
        deepUnitChargeType: undefined,
        targetType: "",
        cutoff: "",
        platform: "",
        consumeStartDateEnd: todayStr,
        consumeEndDateEnd: todayStr,
        startDateCreate: null,
        endDateCreate: null,
        startDateEnd: null,
        endDateEnd: null,
        circulationDateStart: null,
        circulationDateEnd: null,
        consumeAmountMin: null,
        consumeAmountMax: null,
        unitPriceMin: null,
        unitPriceMax: null,
        conversionMin: null,
        conversionMax: null,
        conversionCostMin: null,
        conversionCostMax: null,
      },
      // 列表相关
      list: [],
      loading: false,
      finished: false,
      selectedItems: [],
      selectedItemsData: [], // 选中完整数据
      // 更多筛选条件
      selectedCount: 0,
      debounceTimeout: null, // 防抖定时器
    };
  },
  async created() {
    await this.loadProducts(); // 加载产品数据
    this.parameter.pageNo = 1;
    await this.fetchListData();
    console.log(this.$route);
  },
  methods: {
    // 根据后台返回的值查找对应的label
    getStatusLabel(value) {
      const ordersStatusOptions = [
        {
          value: "0",
          label: "未知",
        },
        {
          value: "1",
          label: "待接单",
        },
        {
          value: "2",
          label: "任务待审核",
        },
        {
          value: "3",
          label: "待支付",
        },
        {
          value: "7",
          label: "取消",
        },
        {
          value: "20",
          label: "执行中",
        },
        {
          value: "21",
          label: "待发布",
        },
        {
          value: "22",
          label: "发布完成",
        },
        {
          value: "23",
          label: "视频审核中",
        },
        {
          value: "24",
          label: "定时发布中",
        },
        {
          value: "30",
          label: "拒绝接单",
        },
        {
          value: "31",
          label: "订单成功",
        },
        {
          value: "32",
          label: "订单失败",
        },
        {
          value: "33",
          label: "任务审核失败",
        },
        {
          value: "34",
          label: "支付失败",
        },
        {
          value: "35",
          label: "视频审核拒绝",
        },
        {
          value: "36",
          label: "达人超时未接单",
        },
        {
          value: "37",
          label: "网红超时未上传视频",
        },
        {
          value: "38",
          label: "素材视频审核中",
        },
        {
          value: "39",
          label: "素材视频审核拒绝",
        },
        {
          value: "40",
          label: "待达人改价",
        },
        {
          value: "41",
          label: "待确认价格",
        },
        {
          value: "42",
          label: "客户已驳回，待达人重新改价",
        },
        {
          value: "43",
          label: "达人改价超时，已失效",
        },
        {
          value: "44",
          label: "确认改价超时，已失效",
        },
        {
          value: "45",
          label: "待上传脚本",
        },
        {
          value: "46",
          label: "已上传脚本",
        },
        {
          value: "47",
          label: "超时未上传脚本",
        },
        {
          value: "48",
          label: "广告主超时未确认脚本",
        },
        {
          value: "49",
          label: "待平台改价",
        },
        {
          value: "50",
          label: "订单申诉中",
        },
        {
          value: "51",
          label: "订单已终止",
        },
      ];
      const status = ordersStatusOptions.find(
        (option) => option.value === value
      );
      return status ? status.label : "未知状态"; // 如果找不到对应的值，返回 '未知状态'
    },
    // 获取产品列表
    async loadProducts() {
      const res = await ProductData({
        pageNo: 1,
        pageSize: 9999,
      });
      this.allProducts = res.map((item) => ({
        label: item.productName,
        value: item.id,
      }));
    },
    // 选择产品 根据产品筛选对应账户
    async handleProductSelect(id) {
      this.parameter.productId = id;
      this.parameter.advertiserId = "";
      this.allAdvert = [];
      const res = await AccountData({
        productId: id,
        dataType: "1",
      });
      this.allAdvert = res.list.map((item) => ({
        label: item.advertiserId,
        value: item.advertiserId,
      }));
      // (this.list = []), (this.finished = false);
      this.loading = true;
      this.clearSelection();
      this.handleQuery();
    },
    // 根据产品选择账户
    handleAdvertSelect(id) {
      this.parameter.advertiserId = id;
      // (this.list = []), (this.finished = false);
      this.loading = true;
      this.clearSelection();
      this.handleQuery();
    },
    // 输入框内容发生变化时
    changeInput() {
      // 每次输入时先清除上一次的定时器
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      // 设置新的定时器，延迟500毫秒后执行查询
      this.debounceTimeout = setTimeout(() => {
        // (this.list = []), (this.finished = false);
        this.loading = true;
        this.handleQuery();
      }, 500); // 500ms 防抖时间
    },

    // 获取列表数据
    async fetchListData() {
      try {
        const res = await getnewBoostList(this.parameter);
        if (res.list && res.list.length > 0) {
          if (this.parameter.pageNo === 1) {
            this.list = res.list;
          } else {
            this.list = [...this.list, ...res.list];
          }
        } else {
          this.finished = true;
        }

        // 检查是否已加载全部数据
        if (res.list.length < this.parameter.pageSize) {
          this.finished = true;
        }
      } catch (error) {
        console.error("获取列表数据出错:", error);
      } finally {
        this.loading = false;
      }
    }, // 触底加载新数据
    async handleQueryBotoomOut() {
      if (this.finished) return;
      this.parameter.pageNo++;
      await this.fetchListData();
    },
    // 全选
    selectAll() {
      this.selectedItems = this.list.map((item) => item.orderId);

      this.selectedCount = this.selectedItems.length;
    },
    // 清空选择
    clearSelection() {
      this.selectedItems = [];
      this.selectedCount = 0;
    },
    // 选择状态
    handleStateChange() {
      this.handleQuery();
    },
    // 刷新列表数据
    async handleQuery() {
      this.clearSelection();
      this.parameter.pageNo = 1;
      this.list = [];
      this.finished = false;
      this.loading = true;
      await this.fetchListData();
    },

    // 切换选择项
    toggleSelect(id) {
      const index = this.selectedItems.indexOf(id);
      if (index === -1) {
        this.selectedItems.push(id);
      } else {
        this.selectedItems.splice(index, 1);
      }
      this.selectedItemsData = this.list.filter((item) =>
        this.selectedItems.includes(item.orderId)
      );
      this.selectedCount = this.selectedItems.length;
    },
    // 跳转到批量新增页面
    pushAddBoost() {
      this.$router.push({
        name: "addBoost",
        params: {
          selectedCount: this.selectedCount,
          selectedItems: this.selectedItems,
          array: this.selectedItemsData,
        },
      });
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.dashboard {
  height: 100vh;
  display: flex;
  flex-direction: column;

  .booster-list-page {
    flex: 1;
    // overflow-y: auto;
    // margin-bottom: 70px; /* 底部TabBar高度 */
    padding: 0 6px;
    padding-bottom: 70px; /* 底部TabBar高度 */
    box-sizing: border-box;

    // -------------------------头部筛选固定区域--------------------------------------------------
    .fixed-header {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 100;
      background: #ffffff;
      height: 150px;

      .sub-header {
        width: 100%;
        height: 100%;
        // box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.1),
        //   0px 0px 6px 0px rgba(0, 0, 0, 0.09),
        //   0px 0px 8px 0px rgba(0, 0, 0, 0.05);
        border-radius: 0px 0px 6px 6px;
        border: 1px solid #ffffff;
        padding: 0 5px 5px 5px;
        box-sizing: border-box;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .head_info {
          display: flex;
          justify-content: space-between;
          font-family: PingFang SC;
          font-weight: 600;
          font-size: 20px;
          line-height: 20px;
          margin-top: 30px;

          span {
            display: flex;
            align-items: center;
          }
        }

        .filtrate {
          display: flex;
          flex-wrap: wrap;
          // padding: 0 3px;
          margin-top: 5px;

          .fit_item {
            width: 50%;
            box-sizing: border-box;
            padding: 0 8px;
            ::v-deep .selector-input {
              width: 99%;
            }
            .enter-input {
              width: 100%;
              height: 22px;
              border-radius: 2px;
              border: 1px solid #ded9d9;
              font-family: Inter;
              font-weight: 400;
              font-size: 10px;
              color: #000000;
              align-items: center;
              margin: 5px 0;
              padding: 0 10px;
              box-sizing: border-box;
            }
          }

          .fit_item:nth-child(1n) {
            padding-left: 0;
          }

          .fit_item:nth-child(2n) {
            padding-right: 0;
          }

          .fit_item:nth-child(3) {
            width: 100%;
            padding: 0;
          }

          .van-button--mini {
            margin-top: 4px;
          }
        }

        .selection-status {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          // padding: 0 3px;
          box-sizing: border-box;

          .selected-count {
            font-size: 12px;
            color: #000000;
          }

          a {
            font-family: Inter;
            font-weight: 400;
            font-size: 12px;
            color: #000000;
            line-height: 14px;
            margin-left: 13px;
          }
        }
      }
    }

    // -------------------------列表块--------------------------------------------------
    .van_list {
      height: calc(100vh - 222px);
      // flex: 1;
      overflow-y: auto;
      // background-color: aquamarine;
      margin-top: 150px;
      padding: 5px 0;
      box-sizing: border-box;

      .van-swipe-cell {
        border-radius: 4px;
        // padding-top: 6px;

        .booster-item {
          padding: 11px 5px;
          box-sizing: border-box;
          margin-bottom: 10px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid #f0ecec;
          position: relative;
        }

        .booster-item.selected {
          background: #e4effc;
          border: 1px solid #e4effc;
        }

        .item-header {
          position: absolute;
          top: -6px;
          left: 5px;
          padding: 1px 4px;
          box-sizing: border-box;
          background: #7eaffb;
          border-radius: 2px;
          font-family: Inter;
          font-weight: 400;
          font-size: 10px;
          color: #ffffff;
        }

        .item-stats {
          display: flex;
          flex-wrap: wrap;

          span {
            width: 65%;
            font-family: Inter;
            font-weight: 400;
            font-size: 10px;
            color: #000000;
            margin: 5px 0;
          }

          span:nth-child(2n) {
            width: 35%;
          }
        }

        .special-time {
          color: #ff976a;
          display: flex;

          span {
            // margin-right: 15px;
            font-family: Inter;
            font-weight: 400;
            font-size: 10px;
            color: #000000;
          }
        }

        &.selected {
          .booster-item {
            background-color: #f0f7ff;
            border: 1px solid #1989fa;
          }
        }

        .van-button {
          width: 52px;
          height: 100%;
          border-radius: 2px;
          margin-left: 6px;
          font-family: Inter;
          font-weight: 400;
          font-size: 10px;
          color: #ffffff;
          padding: 0;
          border: none;
        }
      }
    }

    .next_step {
      position: fixed;
      bottom: 85px;
      right: 39px;
    }
  }
}
</style>
